import { SelectOption } from '../../../logic/types'
import { Getaway, SelectedShop, Shop, Tariff } from './types'

export const getShopPriorityList = (): Array<Shop> => [ Shop.Local, Shop.Global, Shop.Crypto, Shop.Bonus, Shop.Llc ]

export const getShopsGetawayPriorityCodeList = (): {[key: string]: Array<string>} => ({ [Shop.Local]: [ 'sberbank_business' ] })

export const getGetawayRequiredFieldSelectOptions = (optionsRawMap: { [key: string]: any }): Array<SelectOption> => Object.keys(optionsRawMap).map((key) => ({
  label: optionsRawMap[key],
  value: key,
}))

// eslint-disable-next-line complexity
export const defaultShopTypeOfSelectedTariff = (shops: Tariff['shops']): SelectedShop | null => {
  const shopsList: Array<Shop> = getShopPriorityList()

  for (const shop of shopsList) {
    if (
      shops[shop]
      && shops[shop]?.length
    ) {
      return {
        group: shop,
      }
    }
  }

  return null
}
